import React from "react";

const CareerSlider = () => {

    return (
        <>
            <section className={'career-slider'}>
                    <div className={'d-flex'}>
                            <div className={"logo-slider"}>
                                <div>
                                    <img src={"/images/career/middleware-career.png"} alt={"Middleware"} width={200}
                                         height={200} className={"even-width"}/>
                                    <img src={"/images/career/mw-event.png"} alt={"Middleware Event"} width={200}
                                         height={200} className={"odd-width"}/>
                                    <img src={"/images/career/event-recaption.png"} alt={"Middleware recaption"} width={200}
                                         height={200} className={"even-width"}/>
                                    <img src={"/images/career/mw-slider-team.png"} alt={"Middleware Team"} width={200}
                                         height={200} className={"odd-width"}/>
                                    <img src={"/images/career/mw-box-cricket.png"} alt={"Sports Team"} width={200}
                                         height={200} className={"even-width play-team"}/>
                                    <img src={"/images/career/play-team.png"} alt={"Middleware Cricket Team"} width={200}
                                         height={200} className={"odd-width play-team-tt"}/>

                                    <img src={"/images/career/middleware-career.png"} alt={"Middleware Event"} width={200}
                                         height={200} className={"even-width"}/>
                                    <img src={"/images/career/mw-event.png"} alt={"Middleware"} width={200}
                                         height={200} className={"odd-width"}/>
                                    <img src={"/images/career/event-recaption.png"} alt={"Middleware Team"} width={200}
                                         height={200} className={"even-width"}/>
                                    <img src={"/images/career/mw-slider-team.png"} alt={"Sports Team"} width={200}
                                         height={200} className={"odd-width"}/>
                                    <img src={"/images/career/mw-box-cricket.png"} alt={"Middleware Cricket Team"} width={200}
                                         height={200} className={"even-width play-team"}/>
                                    <img src={"/images/career/play-team.png"} alt={"Middleware Team"} width={200}
                                         height={200} className={"odd-width play-team-tt"}/>

                                    <img src={"/images/career/middleware-career.png"} alt={"FinFlx"} width={200}
                                         height={200} className={"even-width"}/>
                                    <img src={"/images/career/mw-event.png"} alt={"Puresend"} width={200}
                                         height={200} className={"odd-width"}/>
                                    <img src={"/images/career/event-recaption.png"} alt={"Markovml"} width={200}
                                         height={200} className={"even-width"}/>
                                    <img src={"/images/career/mw-slider-team.png"} alt={"Sportkeda"} width={200}
                                         height={200} className={"odd-width"}/>
                                    <img src={"/images/career/mw-box-cricket.png"} alt={"Opslogic"} width={200}
                                         height={200} className={"even-width play-team"}/>
                                    <img src={"/images/career/play-team.png"} alt={"Savvy"} width={200}
                                         height={200} className={"odd-width play-team-tt"}/>

                                </div>

                            </div>
                    </div>
            </section>
        </>
    );
};

export default CareerSlider;
